<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableWebDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="webDelmodal = true"
            v-hasPermission="['network:webMonitor:delete']"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
        <Button
          type="info"
          size="small"
          @click="rowClick(row)"
          v-hasPermission="['network:webMonitor:detail']"
          >{{ $t("alarms.common.details") }}</Button
        >
      </template>
    </Table>
    <!-- 删除模式框 -->
    <Modal v-model="webDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ webName }}
          {{ $t("alarms.common.allWarningRules") }} ？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeWeb()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableWebVue = {};
export default {
  name: "TableWeb",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      webDelmodal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      webName: "",
      columns: [
        {
          title: this.$t("alarms.network.AppService.name"),
          key: "name"
        },
        {
          title: this.$t("alarms.instance.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.instance.accountType"),
          key: "accountTypeName"
        },
        {
          title: this.$t("alarms.network.AppService.status"),
          key: "state"
        },
        {
          title: this.$t("alarms.network.AppService.appType"),
          key: "type"
        },
        {
          title: this.$t("alarms.network.AppService.appPlan"),
          key: "serverFarm"
        },
        {
          title: this.$t("alarms.network.AppService.resourceGroup"),
          key: "resourceGroup"
        },
        {
          title: this.$t("alarms.network.AppService.location"),
          key: "region"
        },
        {
          title: this.$t("alarms.network.AppService.subscription"),
          key: "subscriptionName"
        },
        {
          title: this.$t("common.operation"),
          width: 150,
          slot: "delete"
        }
      ],
      tableWebDate: []
    };
  },
  beforeCreate: function() {
    tableWebVue = this;
  },
  created() {
    // 获取WebMonitorSearch里面的搜索内容
    eventBus.$on("webName", function(val) {
      tableWebVue.webName = val;
    });
    // 获取WebMonitorSearch里面的搜索内容
    eventBus.$on("companyId", function(val) {
      tableWebVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableWebVue.getWebData();
    },
    // 分页显示数据
    /****************************************************/
    getWebData: function() {
      //分页
      this.$api.resourceAzureAppService
        .pageWeb({
          pageNum: this.current,
          pageSize: this.pageSize,
          name: tableWebVue.webName,
          companyId: tableWebVue.companyId
        })
        .then(res => {
          this.tableWebDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableWebVue.getWebData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableWebVue.getWebData();
    },
    // 销毁webNameSearchID
    beforeDestroy: function() {
      eventBus.$off("webNameSearchID");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.webName = this.tableWebDate[index].name;
    },
    removeWeb: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.resourceAzureAppService
        .deleteWeb("id", this.tableWebDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableWebVue.getWebData();
            this.isDisable = false;
            this.modal_loading = false;
            this.webDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/network/webDetail/",
        query: {
          id: row.id,
          accountId: row.accountId,
          region: row.region,
          accountTypeName: row.accountTypeName,
          accountName: row.accountName,
          name: row.name
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/web/TableWeb.vue